export function RateLockPeriodIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="44.41"
      height="44.41"
      viewBox="0 0 44.41 44.41"
      {...props}
    >
      <g id="icons">
        <g id="rate_lock_period" data-name="rate lock period">
          <path className="cls-1"
                d="m22.21,44.41C9.96,44.41,0,34.45,0,22.21S9.96,0,22.21,0s22.21,9.96,22.21,22.21-9.96,22.21-22.21,22.21Zm0-43.41C10.51,1,1,10.51,1,22.21s9.51,21.21,21.21,21.21,21.21-9.51,21.21-21.21S33.9,1,22.21,1Z"/>
          <path className="cls-1"
                d="m30.55,29.88c-.18,0-.35-.05-.51-.14l-8.83-5.3v-12.25c0-.55.45-1,1-1s1,.45,1,1v11.12l7.86,4.72c.47.28.63.9.34,1.37-.19.31-.52.49-.86.49Z"/>
        </g>
      </g>
    </svg>
  );
}
